import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

function TraspasosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_TRASPASOS_SALIDA = process.env.REACT_APP_URL_TRASPASOS_SALIDA;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [areas, setAreas] = useState([]);
  const [inventarios, setInventarios] = useState([]);
  const [cargandoInv, setCargandoInv] = useState(false);

  const [selectedAreaSalida, setSelectedAreaSalida] = useState("");
  const [selectedAreaDestino, setSelectedAreaDestino] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_cantidad, setTotalCantidad] = useState(0);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      inventarios: "",
      cantidad: 0,
      disponible: 0,
      ubicacion: "NA",
      costoUnitario: 0,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setAreas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Al elegir el almacen de origen se cargan sus existencias
  function jalaAlmacenSalida(e) {
    setSelectedAreaSalida(e);
    limpiaArticulos();
    setInventarios([]);
    if (!e || e === "0") return;
    setCargandoInv(true);
    axios
      .get(`${URL_INVENTARIOS}AcumuladoAlmacen/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setInventarios(res.data.filter((a) => a.cantidad > 0));
        setCargandoInv(false);
      })
      .catch((err) => {
        console.log(err);
        setCargandoInv(false);
      });
  }

  function limpiaArticulos() {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        inventarios: "",
        cantidad: 0,
        disponible: 0,
        ubicacion: "NA",
        costoUnitario: 0,
      },
    ]);
    setTotalCantidad(0);
  }

  const saveTraspaso = async (event) => {
    event.preventDefault();

    if (!selectedAreaSalida || selectedAreaSalida === "0") {
      return Swal.fire({ icon: "error", title: "Oops...", text: "Selecciona el Almacen de Salida" });
    }
    if (!selectedAreaDestino || selectedAreaDestino === "0") {
      return Swal.fire({ icon: "error", title: "Oops...", text: "Selecciona el Almacen Destino" });
    }
    if (selectedAreaSalida === selectedAreaDestino) {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El Almacen de Salida y el Destino no pueden ser el mismo",
      });
    }

    const articulosValidos = inputFields.filter(
      (a) => a.articulos !== "" && parseFloat(a.cantidad) > 0
    );
    if (!articulosValidos.length) {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Agrega al menos un articulo con cantidad mayor a 0",
      });
    }

    const sinExistencia = articulosValidos.find(
      (a) => parseFloat(a.cantidad) > parseFloat(a.disponible)
    );
    if (sinExistencia) {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `No hay existencia suficiente (disponible ${sinExistencia.disponible})`,
      });
    }

    Swal.fire({
      title: "Estas seguro?",
      text: "Se hara la salida del almacen de origen y la entrada en el destino!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setValidaBoton(false);
      toggleProgreso();
      try {
        await axios.post(
          `${URL_TRASPASOS_SALIDA.replace("traspasosSalida", "traspasosCompleto")}`,
          {
            fecha,
            areaSalida: selectedAreaSalida,
            areaDestino: selectedAreaDestino,
            observaciones,
            user: user.id,
            articulos: articulosValidos.map((a) => ({
              articulos: a.articulos,
              inventarios: a.inventarios,
              cantidad: parseFloat(a.cantidad),
              ubicacion: a.ubicacion || "NA",
              costoUnitario: parseFloat(a.costoUnitario) || 0,
            })),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        await axios
          .post(
            URL_LOGS,
            {
              tipo: "Crear Traspaso",
              detalle: `Traspaso de ${total_cantidad} pzas`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .catch((err) => console.log(err));

        Swal.fire("Good job!", "Traspaso creado con exito", "success");
        setTimeout(() => {
          window.location.href = "/ListadoTraspasosSalida";
        }, 1000);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || ""}`,
        });
        console.log(error);
        setValidaBoton(true);
        setModalProgreso(false);
      }
    });
  };

  function BuscaArticulo(id, selectedInventario) {
    if (!selectedInventario) return;
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = selectedInventario.idArticulo;
        i.inventarios = selectedInventario._id;
        i.disponible = selectedInventario.cantidad;
        i.ubicacion = selectedInventario.ubicacion || "NA";
        i.costoUnitario = selectedInventario.costoUnitario || 0;
        i.cantidad = 0;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  }

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  };

  function ActualizaTotales(campos) {
    const cant = campos.map((c) => parseFloat(c.cantidad) || 0);
    setTotalCantidad(cant.reduce((t, total) => t + total, 0));
  }

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        inventarios: "",
        cantidad: 0,
        disponible: 0,
        ubicacion: "NA",
        costoUnitario: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    ActualizaTotales(values);
  };

  const options = inventarios.map((option) => {
    const junta = `${option.SKU} ${option.nombre} ${
      option.ubicacion && option.ubicacion !== "NA" ? option.ubicacion : ""
    }`;
    const firstLetter = String(option.SKU || "0")[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_traspasos_salida ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Traspaso</h3>
          <h5 align="center" style={{ color: "#64748b" }}>
            Descuenta del almacen de origen y lo suma en el destino en un solo paso
          </h5>
          <Form onSubmit={saveTraspaso}>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Almacen Salida</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedAreaSalida}
                  required
                  onChange={(e) => {
                    jalaAlmacenSalida(e.target.value);
                  }}
                >
                  <option value="">Selecciona un almacen</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Almacen Destino</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedAreaDestino}
                  required
                  onChange={(e) => {
                    setSelectedAreaDestino(e.target.value);
                  }}
                >
                  <option value="">Selecciona un almacen</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a._id !== selectedAreaSalida) {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </Col>
              <Col md={4}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTAL {new Intl.NumberFormat("en-US").format(total_cantidad)} pzas.
                </h4>
              </Col>
            </Row>

            {cargandoInv ? (
              <h6>
                <i
                  className="fas fa-hourglass-half custom-spin"
                  style={{ marginRight: "10px" }}
                ></i>
                Cargando existencias del almacen...
              </h6>
            ) : undefined}

            {/* Tabla Articulos */}
            <Row>
              <Col md={6}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Ubicacion</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Disponible</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={6}>
                    <Autocomplete
                      size="small"
                      value={inputField.articulosNombre}
                      onChange={(event, selectedInventario) => {
                        BuscaArticulo(inputField.id, selectedInventario);
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.SKU} {option.nombre} / Disp: {option.cantidad}
                          {option.ubicacion && option.ubicacion !== "NA"
                            ? ` / ${option.ubicacion}`
                            : ""}
                        </React.Fragment>
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      name="ubicacion"
                      type="text"
                      value={inputField.ubicacion}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      name="disponible"
                      type="number"
                      value={inputField.disponible}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      max={inputField.disponible}
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoTraspasosSalida"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{ width: "50px", height: "50px", color: "#232B41" }}
                />
                <Spinner
                  style={{ width: "50px", height: "50px", color: "#232B41" }}
                />
                <Spinner
                  style={{ width: "50px", height: "50px", color: "#232B41" }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default TraspasosCreate;
